import { useEffect } from 'react';
import api from '@/lib/api';

export default function GA4() {
  useEffect(() => {
    api.get('/public/settings').then((res) => {
      const id = res.data?.ga4_id;
      if (!id) return;
      if (document.getElementById('ga4-script')) return;
      const s = document.createElement('script');
      s.id = 'ga4-script';
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(s);
      const cfg = document.createElement('script');
      cfg.id = 'ga4-config';
      cfg.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config','${id}');`;
      document.head.appendChild(cfg);
      window.gtag = window.gtag || function () { (window.dataLayer = window.dataLayer || []).push(arguments); };
    }).catch(() => {});
  }, []);
  return null;
}

export function trackEvent(name, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}
